import { create } from 'zustand'
import { api } from '@/api/client'
import type { Tag } from '@/types/models'
import { useSpaceStore } from './spaceStore'

function getTagsUrl(): string {
  const { activeSpace, currentSpace } = useSpaceStore.getState()
  if (activeSpace.startsWith('space:') && currentSpace) {
    return `/api/spaces/${currentSpace.id}/tags`
  }
  return '/api/tags'
}

interface TagsState {
  tags: Tag[]
  loaded: boolean
  error: string | null
  loadTags: () => Promise<void>
  addTag: (tag: Tag) => Promise<void>
  updateTag: (name: string, data: Partial<Tag>) => Promise<void>
  deleteTag: (name: string) => Promise<void>
}

export const useTagsStore = create<TagsState>()((set, get) => ({
  tags: [],
  loaded: false,
  error: null,

  loadTags: async () => {
    try {
      const tagsData = await api.get<Tag[]>(getTagsUrl())
      set({ tags: Array.isArray(tagsData) ? tagsData : [], loaded: true, error: null })
    } catch (e) {
      set({ loaded: true, error: e instanceof Error ? e.message : '加载失败' })
    }
  },

  addTag: async (tag) => {
    await api.post(getTagsUrl(), tag)
    await get().loadTags()
  },

  updateTag: async (name, data) => {
    await api.patch(`${getTagsUrl()}/${encodeURIComponent(name)}`, data)
    await get().loadTags()
  },

  deleteTag: async (name) => {
    await api.delete(`${getTagsUrl()}/${encodeURIComponent(name)}`)
    await get().loadTags()
  },
}))
